export const formatCurrency = (value: number): string => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(value);
};

export const formatPercentage = (value: number): string => {
  return `${value}%`;
};

export const parseInputValue = (value: string): number => {
  return parseFloat(value.replace("%", ""));
};
